import { parseRange } from './locationUtils';
import { DEFAULT_RANGE, SESSION_RANGE_KEY } from '../global-constants';
/**
 * Returns the persisted search range from sessionStorage, falling back to
 * DEFAULT_RANGE.
 *
 * sessionStorage.getItem() always returns a string (or null), but range is a
 * number downstream. Normalize through parseRange so the value is always a
 * number.
 */
export const getInitialRange = () => {
	try {
		return parseRange(
			sessionStorage.getItem(SESSION_RANGE_KEY),
			DEFAULT_RANGE
		);
	} catch (e) {
		return DEFAULT_RANGE;
	}
};
